import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { GrupoProdutoService } from '../services/grupo-produto.service'
import Swal from 'sweetalert2';
import * as moment from 'moment';


@Component({
	selector: 'app-grupos-produto-edit',
	templateUrl: './grupos-produto-edit.component.html',
	styleUrls: ['./grupos-produto-edit.component.css'],
	animations: [loadingFade]
})
export class GruposProdutoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public grupo_produto_id = null;
	public isLote = false;
	public isLoteCheckBox = false;
	public href: string = "";
	public hiddenSubmit = false;

	public grupo_produto_status;

	public formGrupoProduto: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private grupoProdutoSvc: GrupoProdutoService,
				private router: Router) { }

	ngOnInit() {

        this.href = this.router.url;
        let path = this.router.url;	
		let pathS = path.split("/"); 

		if(pathS[3] == "ver"){
			this.criaFormDisabled();
			this.hiddenSubmit = true;
		}else{
			this.criaForm();
		}

		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.grupo_produto_id = params.id;
				// pega dados a partir do id
				this.grupoProdutoSvc.getGrupoProduto(params.id).then((data: any) => {
					this.preencheForm({
						grupo_produto_id: data.grupo_produto_id,
						grupo_produto_nome: data.grupo_produto_nome,
						grupo_produto_lote: data.grupo_produto_lote,
						grupo_produto_lote_nome: data.grupo_produto_lote_nome,
						grupo_produto_data_validade: data.grupo_produto_data_validade != null ? moment(data.grupo_produto_data_validade).format('DD/MM/YYYY') : '',
						grupo_produto_status: data.grupo_produto_status == 'A' ? true : false 
					});


					/*if(data.grupo_produto_lote){
						this.isLote = true;
					}*/

					this.loading = false;

				});
			}
			else {
				this.loading = false;
			}
		});



	}

	criaForm() {
		this.formGrupoProduto = this.fb.group({
			grupo_produto_id: null,
			grupo_produto_nome: ['', Validators.required],
			grupo_produto_lote: false,
			grupo_produto_lote_nome: null,
			grupo_produto_data_validade: null,
			grupo_produto_status: null
		});
	}

	criaFormDisabled() {
		this.formGrupoProduto = this.fb.group({
			grupo_produto_id: {value: null, disabled: true},
			grupo_produto_nome: {value: null, disabled: true},
			grupo_produto_lote: {value: null, disabled: true},
			grupo_produto_lote_nome: {value: null, disabled: true},
			grupo_produto_data_validade: {value: null, disabled: true},
			grupo_produto_status: {value: null, disabled: true}
		});
	}

	preencheForm(dados) {
		this.formGrupoProduto.setValue(dados);
	}

	enviaGrupoProduto() {
		if (this.formGrupoProduto.valid) {
			this.submitting = true;

			let toSend = this.formGrupoProduto.value;

			let grupo_produto_data_validade = "";

			


			if (this.grupo_produto_id === null) { // criar


				if(toSend.grupo_produto_data_validade != null ){
					grupo_produto_data_validade = toSend.grupo_produto_data_validade.substr(4, 4);
					grupo_produto_data_validade += toSend.grupo_produto_data_validade.substr(2, 2);
					grupo_produto_data_validade += toSend.grupo_produto_data_validade.substr(0, 2);
					  toSend.grupo_produto_data_validade = grupo_produto_data_validade;
				}
	
				toSend.grupo_produto_status = "A";

				this.grupoProdutoSvc.criaGrupoProduto(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Grupo cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/grupos-produto']);
						}
					  });
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar

				toSend.grupo_produto_status = toSend.grupo_produto_status ? 'A' : 'I';

				if(toSend.grupo_produto_data_validade != null ){

					console.log( toSend.grupo_produto_data_validade);

					let grupo_produto_data_validade_r = toSend.grupo_produto_data_validade.replace("/","").replace("/","");
					grupo_produto_data_validade = grupo_produto_data_validade_r.substr(4, 5);
					grupo_produto_data_validade += grupo_produto_data_validade_r.substr(2, 2);
					grupo_produto_data_validade += grupo_produto_data_validade_r.substr(0, 2);
					toSend.grupo_produto_data_validade = grupo_produto_data_validade;
				  }

				  console.log(toSend.grupo_produto_data_validade);
	
				this.grupoProdutoSvc.editaGrupoProduto(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Grupo alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/grupos-produto']);
						}
					  });
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formGrupoProduto.controls){
				let campo = this.formGrupoProduto.get(field);
				campo.markAsTouched();
			}
     		this.submitting = false;
			Swal.fire({
				type:'error',
				title:'Atenção!',
				text:'Verifique os campos obrigatórios e tente novamente.'

			});
		}
	}

	invalid(nome) {
		let input = this.formGrupoProduto.get(nome);
		return input.touched && input.invalid;
	}

	onClickCheckLote(e){

		if(!this.formGrupoProduto.controls.grupo_produto_lote.value){
			this.isLote = true;
		}else{
			this.isLote = false;
		}

	}
}
